<template>
  <div
    class="export_completed_notification items-start"
    :class="{ unseen: !isRead }"
  >
    <ThemeImage
      :icon="imageNames.SUPER_AGI_LOGO_ROUND"
      alt="icon"
      class="notification_icon"
    />
    <div class="flex flex-col gap-[6px] flex-grow min-w-0">
      <span class="proxima_nova text-sm font-normal text_color">{{
        `Your export “${exportName}” has been completed`
      }}</span>

      <div class="secondary_color text-xs text-nowrap">
        {{ formatTimestamp(createdTime, "timestamp", formatTypes.centered) }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { formatTimestamp } from "@/src/utils/dateTimeUtils.js";
import { formatTypes } from "@/src/constants/dateTimeConstants.js";
import { imageNames } from "@/src/constants/imageConstants.js";

const props = defineProps({
  exportName: {
    type: String,
    required: true,
  },
  createdTime: {
    type: String,
    required: true,
  },
  isRead: {
    type: Boolean,
    required: true,
  },
});
</script>

<style scoped>
.export_completed_notification {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  transition: background-color 0.2s ease-in-out;
  cursor: pointer;
  border-radius: 8px;
}

.export_completed_notification.unseen {
  border-radius: 8px;
  background: rgba(112, 149, 235, 0.12);
}

.export_completed_notification:hover {
  background-color: var(--white-opacity-8);
}

.export_completed_notification.unseen:hover {
  background:
    linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.08) 0%,
      rgba(255, 255, 255, 0.08) 100%
    ),
    rgba(112, 149, 235, 0.12);
}
</style>
